const tags = [
  {
    id: 'javascript',
    text: 'JavaScript',
    isWrittenByMe: true,
    isSVG: true,    
  },
  {
    id: 'angular',
    text: 'Angular',
    isWrittenByMe: true,
    isSVG: true,
  },
  {
    id: 'vue',
    text: 'Vue',
    isWrittenByMe: true
  },  
  {
    id: 'react',
    text: 'React',
    isWrittenByMe: true,
    isSVG: true,
  },
  // {
  //   id: 'preact',
  //   text: 'Preact'
  // },
  {
    id: 'react-native',
    text: 'React Native'
  },
  // {
  //   id: 'redux',
  //   text: 'Redux'
  // },
  // {
  //   id: 'micro-frontends',
  //   text: 'Micro Frontend'
  // },
  {
    id: 'frameworks',
    text: 'Frameworks Mix'
  },        
  {
    id: 'nodejs',
    text: 'Node',
  },
  {
    id: 'typescript',
    text: 'TypeScript',
    isWrittenByMe: true
  },
  {
    id: 'best-practices',
    text: 'Best Practices'
  },
  {
    id: 'life',
    text: 'Lifestyle',
    isWrittenByMe: true
  },
  {
    id: 'general',
    text: 'General',
    isWrittenByMe: true
  },
  {
    id: 'oos',
    text: 'Out of Scope'
  },
  {
    id: 'golang',
    text: 'GoLang',
    isSVG: true,
    backgroundColor: '#b8f3c2',
  },
];

export default tags;